import React, { ComponentType } from 'react';
import { AppPageComponent } from '@/types/app';
import withOnlyUnauthorizedUsers from '@/utilities/withOnlyUnauthorizedUsers';
import { CZEN_BASE_PATH } from '@/constants';

/**
 * This is a general code for all enrollment starting points.
 */
export default function withFlowStartPoint<P extends object>(
  Component: ComponentType<P>
): ComponentType<P> {
  const WithOnlyUnauthorizedUsersComponent = withOnlyUnauthorizedUsers(Component, CZEN_BASE_PATH);

  function FlowStartPoint(props: P) {
    return <WithOnlyUnauthorizedUsersComponent {...props} />;
  }

  FlowStartPoint.displayName = `withFlowStartPoint(${Component.displayName || Component.name})`;
  FlowStartPoint.disableScreenViewed = (Component as AppPageComponent).disableScreenViewed;
  FlowStartPoint.Layout = (Component as AppPageComponent).Layout;
  FlowStartPoint.Header = (Component as AppPageComponent).Header;
  FlowStartPoint.Footer = (Component as AppPageComponent).Footer;
  FlowStartPoint.removeBGWrapperClass = (Component as AppPageComponent).removeBGWrapperClass;

  return FlowStartPoint;
}
